import React from "react";

import HeaderBtn from "../../../../../../Components/FinalTable/components/Btns/HeaderBtn";

import { TableHeaderRow } from "../../../../../../Components/FinalTable";

const THead = () => {
  return (
    <div className="w-full">
      <TableHeaderRow>
        <HeaderBtn w={80 / 5} label="CODE" />
        <HeaderBtn w={80 / 5} label=" NAME" />
        <HeaderBtn w={80 / 5} label="Description" />
        <HeaderBtn w={80 / 5} label="DATE ADDED" />
        <HeaderBtn w={80 / 5} label="Actions" />
      </TableHeaderRow>
    </div>
  );
};

export default THead;
